import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { Notifications } from '@guabi/shared';
import { apiGet, apiPost } from '@/lib/api';

export const notificationsKey = (wedId: string) => ['notifications', wedId] as const;

export function useNotifications(wedId: string) {
  return useQuery({
    queryKey: notificationsKey(wedId),
    queryFn: () => apiGet<Notifications>(`/weddings/${wedId}/notifications`),
    // Polled, not pushed. Two people planning one wedding do not need websockets,
    // and a minute's lag on "Nicole rated a venue" costs nobody anything.
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });
}

export function useMarkSeen(wedId: string) {
  const qc = useQueryClient();
  return useMutation<{ seenAt: string }, Error, void>({
    mutationFn: () => apiPost<{ seenAt: string }>(`/weddings/${wedId}/notifications/seen`, {}),
    onSuccess: () => void qc.invalidateQueries({ queryKey: notificationsKey(wedId) }),
  });
}
